export default {
  fr: {
    title: 'Objectifs de développement durable',
  },
  en: {
    title: 'Sustainable development goals',
  },
  'pt-br': {
    title: 'Objetivos de desenvolvimento sustentável',
  },
  es: {
    title: 'Objetivos de desarrollo sostenible',
  },
  de: {
    title: 'Ziele für nachhaltige Entwicklung',
  },
} as const
